<template>
  <div>
    <Header />
      <v-dialog persistent content-class="innerExPan" v-model="Loaderdialog"  id="innerExPan" >
        <v-row no-gutters>
          <v-col cols="12" sm="12" style="text-align:center">
            <img  :src="require('@/assets/images/loader.svg')"  />
          </v-col>
        </v-row>
      </v-dialog>
  <v-snackbar Bottom :timeout="timeout" color="green"  v-model="snackbar">
        {{ SnackbarMessege }}
      </v-snackbar> 
      <v-card style="padding: 5px;">
     
      
      <v-expansion-panels style=" border-bottom-right-radius: 0px;
      border-bottom-left-radius: 0px;">
                <v-expansion-panel
                  v-for="(item, i) in 1"
                  :key="i"
                  style="padding-left: 0px;"
                >
                  <v-expansion-panel-header
  
                    class="headernew"
                    style="text-align:center !important;min-height: 20px !important;max-height: 20px;
      padding-left: 6px;"
                    expand-icon=""
                  >
  
  
                     <span
                      style="text-align:right;padding-left: 10px !important;margin-left: -11px;"
                      ><v-icon
                        style="    font-size: 13px !important;"
                        @click="GoBackPrevious()"
                        >fa-arrow-left</v-icon
                      ></span
                    >
                    <v-col
                      cols="12"
                      sm="12"
                      style="padding: 0px !important; text-align: center !important;font-size:12px"
                    >
                      <b
                        style="text-align:center !important; text-transform:uppercase;"
                        >VOUCHER VERIFICATION </b
                      >
                    </v-col>
                  </v-expansion-panel-header>
  
                </v-expansion-panel>
              </v-expansion-panels>
              <v-card-actions style="background: orange;
      padding: 0.6px">
            </v-card-actions>
         <div  class=" .col-12 col-sm-12  " style=" text-align:center;padding-top:5px;background-color:#2196f3;padding-bottom: 7px;padding-top: 7px;border-top-left-radius: 0px;
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
    border-top-right-radius:0px;
    margin-bottom: 4px;padding-right:8px;padding-left:8px">
           <v-row no-gutters >
                <v-col cols="6" style="text-align:left;
    ">
 <!-- <span style="color:#FFF;font-size: 15px;text-align:right;">
        sales #<b>45556</b></span> -->
     <!-- <span style="color:#FFF !important;font-weight: 450;
      font-size: 13px;">
      Sales #4788
      </span> -->
      <v-icon style="font-size:18px; padding-bottom:3px; padding-right:2px;color:#FFF">mdi-account </v-icon>
      <span style="color:#FFF !important;font-weight: 450;
      font-size: 13px;">
      {{CommonObject.PartyName}}
      </span>
        </v-col>
         <v-col cols="6" style="text-align:right;
    ">

  <v-icon style="font-size:18px; padding-bottom:3px; padding-right:2px;color:#FFF">mdi mdi-calendar-month</v-icon>
      <span style="color:#FFF !important;font-weight: 450;
      font-size: 13px;">
       {{ convertDateFormat(VoucherDate) +  "   "+ SetVoucherTime( CommonObject.VoucherDate )}}
      </span>
        </v-col>
        <v-col cols="6" style="text-align:left;
    ">
 <!-- <span style="color:#FFF;font-size: 15px;text-align:right;">
        sales #<b>45556</b></span> -->
     <span style="color:#FFF !important;font-weight: 450;
      font-size: 13px;">
       {{CommonObject.VoucherType}} # {{CommonObject.ReferNo}}
      </span>
        </v-col>
         <v-col cols="6" style="text-align:right;
    ">

    <span style="color:#FFF !important;font-weight: 450;
      font-size: 13px;">
      Items : {{GetVerifiedCount()}}/{{ItemDetails.length}}
      </span>
        </v-col>
      </v-row>
      
      </div>

        <v-row no-gutters>
          <v-col
            cols="12"
            sm="12"
            md="12"
            style="margin-bottom: -19px; padding-top: 2px; margin-top: 5px;"
          >
            <v-text-field
            v-model="Itemsearch"
              type="text"
              placeholder="Search here"
              solo
              rounded
              dense
              append-icon="mdi-magnify"
            >
                <!-- <template v-slot:append-outer>
    <v-icon color="rgb(40 167 69)"  @click="VerifiedItemModal=true" style="padding-right:8px;font-size: 25px !important;">mdi-cart-check</v-icon>
    </template> -->
          </v-text-field>
          </v-col>
        </v-row>
           <v-row
          no-gutters
          style="    font-size: 10px;padding: 5px; background: #343a402e;"
          @click="VerifiedItemModal=true"
        >
          <v-col cols="1" sm="1" >
           No
          </v-col>
          <v-col cols="2" sm="2" class="slno">
          Itemcode
          </v-col>
          <v-col cols="3" sm="3" >
          ItemName
          </v-col>
          <v-col cols="2" sm="2"  style="text-align: center;" v-if="ShowVoucherVerifyActQty === 'True'">
           Actual Qty
          </v-col>
          <v-col cols="2" sm="2" style="text-align: center;">
          varify Qty
          </v-col>
          <v-col cols="2" sm="2" style="text-align: center;">
            Status
          </v-col>
        </v-row>
          <v-row
          class="setmaxrow"
          no-gutters
          style="font-size: 10px !important;text-align: left;padding: 0px;  overflow:scroll;overflow-x: hidden;"
        >
          <v-expansion-panels>
         
            <v-expansion-panel
              v-for="(item, i) in resultQuery"
              :key="i"
              class="ma-0"
              v-touch:tap="touchHandler"
              :id="'color' + i"
            >
              <!-- ----- -->
              <v-expansion-panel-header
                expand-icon=""
                style="min-height: 35px !important;font-size:10px!important;padding:0px"
              >
                <v-col cols="1" sm="1" class="slno1" style="    text-align: left;
    padding-left: 5px;
    ">
                  <b> {{ i + 1 }}</b>
                </v-col>
                <v-col
                  cols="2"
                  sm="2"
                  class="slno"
                  style="padding: 0px !important; "
                >
                  <b>{{item.ItemCode}}</b>
                </v-col>
                <v-col
                  cols="3"
                  sm="3"
                  class="slno"
                  style="padding: 0px !important;"
                >
                  <b>{{item.ItemName}}</b>
                </v-col>
                <v-col
                  cols="2"
                  sm="2"
                  style="padding: 0px !important;text-align: center; "
                  v-if="ShowVoucherVerifyActQty === 'True'"
                >
                  <b>{{item.Qty}} {{item.Unit}} </b>
                </v-col>
                <v-col
                  cols="2"
                  sm="2"
                 
                  style="padding: 0px !important;text-align: center;"
                >
                  <b> {{item.VerifiedQty}} {{item.Unit}} </b>
                </v-col>
                <v-col
                  cols="2"
                  sm="2"
              
                  style="padding: 0px !important;text-align: center; "
                >
                 <v-icon   v-if="item.Qty === item.VerifiedQty" style="color:green;font-size: 15px !important;">mdi mdi-check-decagram</v-icon>
                 <v-icon v-if="item.VerifiedQty === 0" style="color:red;font-size: 15px !important;">mdi mdi-close-circle</v-icon>
                 <v-icon v-if="((item.Qty > 0) && (item.VerifiedQty > 0) &&(item.Qty !== item.VerifiedQty))" style="color:orange;font-size: 15px !important;">mdi mdi-check-decagram</v-icon>
                 <v-icon v-if="((item.Qty === 0) && (item.VerifiedQty > 0))" style="color:orange;font-size: 15px !important;">mdi mdi-check-decagram</v-icon>
                  
                </v-col>
              </v-expansion-panel-header>
              <v-expansion-panel-content style="padding-bottom: 2px !important;">
              <v-divider></v-divider>
             
                <v-row
                  no-gutters
                  style="font-size: 10px;padding: 0px;"
                >
                  <v-col cols="4" sm="4" style="padding-top: 10px;">
                    Barcode<br />
                    <b>{{item.Barcode}}</b>
                  </v-col>
                  <v-col cols="2" sm="2" style="padding-top: 10px;text-align: center;" v-if="ShowVoucherItemRate === 'True' &&  HideItemCostDetails === false">
                    Rate<br />
                    <b>{{FormatewithDecimalPlacesNew(item.Rate)}}</b>
                  </v-col>
                  <v-col cols="2" sm="2" style="padding-top: 10px;text-align: center;" v-if="ShowVoucherItemRate === 'True' &&  HideItemCostDetails === false " >
                    Amount<br />
                    <b>{{FormatewithDecimalPlacesNew(item.TotalAmount)}}</b>
                  </v-col>
                    <v-col cols="2" sm="2" style="padding-top: 10px;text-align: center;" v-if="ShowVoucherItemRate === 'True' &&  HideItemCostDetails === false">
                    Amount <v-icon style="color:green;font-size: 15px !important;" >mdi mdi-check-decagram</v-icon> <br />
                    <b>{{FormatewithDecimalPlacesNew(item.VerifiedAmt)}}</b>
                  </v-col>
                   <v-col cols="2" sm="2" style="text-align: center;padding-top: 5px;">
                  <v-btn
                          outlined
                          x-small
                          fab
                          style="color:#009900;height:20px !important;width:20px !important"
                          @click="OpenVerifiedItemModal(item)"
                         
                        >
                          <v-icon style="font-size: 14px !important;"
                            >mdi-eye</v-icon
                          >
                        </v-btn>
                  </v-col>
                  
                </v-row>
            
              </v-expansion-panel-content>
              <!-- ----- -->
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
              <v-list-item three-line style="padding-right: 5px;padding-left: 5px;padding-bottom: 0px;margin-bottom: -30px;"  v-if="ShowVoucherItemRate === 'True' &&  HideItemCostDetails === false">
      <v-list-item-content style="padding-top: 0px;">

        <v-list-item-title class="headline mb-1 comp1" style="font-size: 15px !important;padding-left:0px;padding-right:0px;text-align:right">
           <div>
       <v-row no-gutters style="    font-size: 10px;padding: 0px; "   v-if="ShowVoucherItemRate === 'True' &&  HideItemCostDetails === false">

 <v-col cols="6" sm="6" xl="6"  style="font-size:10px;padding:0px !important;text-align:left;" >

        <span style="font-size: 10px !important;color:#78909C;padding-right:0px;">Sub Total (Actual) :</span> <b style="font-size: 12px !important;padding-left:2px ">{{FormatewithDecimalPlacesNew( ActualSubTotal)}}</b>
      </v-col>
       <v-col cols="6" sm="6" xl="6"  style="font-size:10px;text-align:right;padding-right:0px !important;" >

        <span style="font-size: 10px !important;color:#78909C;padding-right:0px;">Sub Total (Verify) :</span> <b style="font-size: 12px !important;padding-left:2px ">{{FormatewithDecimalPlacesNew(SubTotal)}}</b>
      </v-col>


           </v-row>
            <v-row no-gutters style="    font-size: 10px;padding: 0px; "   v-if="ShowVoucherItemRate === 'True' &&  HideItemCostDetails === false">

 <v-col cols="6" sm="6" xl="6"  style="font-size:10px;padding:0px !important;text-align:left;" >

         <span style="font-size: 10px !important;color:#78909C;padding-right:0px;">Tax (Actual):</span> <b style="font-size: 12px !important;padding-left:2px ">{{FormatewithDecimalPlacesNew(ActualTotalTax)}}</b>
      </v-col>
       <v-col cols="6" sm="6" xl="6"  style="font-size:10px;text-align:right;padding-right:0px !important;" >

        <span style="font-size: 10px !important;color:#78909C;padding-right:0px;">Tax (Verify):</span> <b style="font-size: 12px !important;padding-left:2px ">{{FormatewithDecimalPlacesNew(TotalTax)}}</b>
      </v-col>


           </v-row>

           <!-- <v-row no-gutters style="    font-size: 10px;padding: 0px; "   v-if="ShowVoucherItemRate === 'True' &&  HideItemCostDetails === false">

           <v-col cols="12" sm="12" xl="12"  style="font-size:10px;text-align:right;padding-right:0px !important" >

        <span style="font-size: 10px !important;color:#78909C;padding-right:0px;">Tax (Actual):</span> <b style="font-size: 12px !important;padding-left:2px ">{{FormatewithDecimalPlacesNew(TotalTax)}}</b>
      </v-col>
         <v-col cols="12" sm="12" xl="12"  style="font-size:10px;text-align:right;padding-right:0px !important" >

        <span style="font-size: 10px !important;color:#78909C;padding-right:0px;">Tax (Verify):</span> <b style="font-size: 12px !important;padding-left:2px ">{{FormatewithDecimalPlacesNew(ActualTotalTax)}}</b>
      </v-col>


           </v-row> -->
           <v-row no-gutters style="    font-size: 10px;padding: 0px; "  v-if="ShowVoucherItemRate === 'True' &&  HideItemCostDetails === false" >

      <v-col cols="6" sm="6" xl="6"    style="font-size:10px;text-align:left;padding:0px" >
          <div class="text-left" style="height:0px !important" >
        <span style="font-size: 10px !important;color:#78909C;">  Net Amount (Actual) :</span> <b style="font-size: 12px !important;"> {{FormatewithDecimalPlacesNew(ActualNetAmount)}}</b>
             </div>
      </v-col>
         <v-col cols="6" sm="6" xl="6"  style="font-size:10px;text-align:right;padding-right:0px !important" >

        <span style="font-size: 10px !important;color:#78909C;padding-right:0px;">  Net Amount (Verify) :</span> <b style="font-size: 12px !important;padding-left:2px ">{{FormatewithDecimalPlacesNew(NetAmount)}}</b>

   
      </v-col>


           </v-row>

           </div>
    
        </v-list-item-title>
        <v-list-item-subtitle >

        </v-list-item-subtitle>
      </v-list-item-content>


    </v-list-item>

      </v-card>
       <v-bottom-sheet v-model="VerifiedItemModal" >
          <v-sheet class="text-center" height="350px" style="padding:10px;">
            <v-row style="border-bottom:1px dotted #000;">
              <v-col cols="12">Item Verification {{ MatchedLabel }}</v-col>
              
              <v-col cols="6" style="padding-top:0px;padding-bottom:0px;margin-bottom: -10px;">
                <v-checkbox
                  style="margin-top: 0px; padding-top: 0px;"
                  v-model="AlwaysopenBarcodeScan"
                  label="Always open cam scanner"
               
                ></v-checkbox>
              </v-col>
            <v-col cols="6" style="padding-top:0px;padding-bottom:0px;padding-right: 16px;text-align: right;margin-bottom: -10px;    margin-top: -15px;" v-if="ShowVoucherVerifyActQty==='True'" >
            <!-- Actual  Qty : <label style="color: #2196F3;">{{ActualQty}} {{Unit}}</label> -->
               <v-switch
      v-model="IsBarcodeScan"
      @change="SetFocusOnItemCode"
      label="Barcode Scan"
    ></v-switch>
            </v-col>
               <v-col cols="12" style="padding-top:0px;padding-bottom:0px;padding-right: 16px;text-align: right;margin-bottom: 3px;    margin-top: -15px;" v-if="ShowVoucherVerifyActQty==='True'" >
            Actual  Qty : <label style="color: #2196F3;">{{ActualQty}} {{Unit}}</label>
         
            </v-col>
            
            <v-col cols="6" style="padding-top:0px;padding-bottom:0px;padding-right: 5px;text-align: left;margin-bottom: 5px;"   v-if="ShowVoucherItemRate==='True' &&  HideItemCostDetails === false">
            Rate: <label style="color: #2196F3;">{{FormatewithDecimalPlacesNew(ItemRate)}}</label>
            </v-col>
             <v-col cols="6" style="padding-top:0px;padding-bottom:0px;margin-bottom: 5px;text-align: right;" v-if="ShowVoucherItemRate==='True' &&  HideItemCostDetails === false">
                  Amount : <label style="color: #2196F3;">{{FormatewithDecimalPlacesNew(ItemAmount)}}</label>
              </v-col>
            </v-row>
            <v-row style="padding-left:10px;padding-right:10px;"     margin-top: -15px;>
              <v-col cols="6">
                <v-text-field
                  v-model="Barcode"
                  outlined
                  id="ebar"
                  autofocus
                  label="Barcode"
                  append-icon="mdi-barcode"
                  @keyup.enter="moveToNext2()"
                  @change="GetItemNameByBarcode()"
                  @click:append="OpenBarcodeReader"
                  v-if="IsBarcodeScan === true"
                ></v-text-field>
                 <v-text-field
                  v-model="ItemCode"
                  outlined
                  id="eitemcode"
                  autofocus
                  label="ItemCode"
                  append-icon="mdi-barcode"
                  @keyup.enter="moveToNext2()"
                  @change="GetItemNameByItemCode()"
                  @click:append="OpenBarcodeReader"
                  v-if="IsBarcodeScan === false"
               
                ></v-text-field>
               
              </v-col>
              <v-col cols="6">
                <v-text-field
                 ref="b_quantity"
                  id="quantity"
                  v-model="VerifyQty"
                  label="Verify Quantity"
                   @keyup.enter="SetVerification()"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row
              style="padding-left:10px;padding-right:10px;margin-top: -30px;"
            >
              <v-col cols="12" style="padding-bottom: 0px;
    margin-bottom: -13px;">
                <v-text-field
                 v-model="ItemName"
                  id="iname"
                  label="Item Name"
              
                  disabled
                  outlined
                ></v-text-field>
           
              </v-col>
            </v-row>
            <v-row  style="justify-content: center;" class="mt-0">
            </v-row>
         
            <v-row >
              <v-col cols="12">
                <v-btn color="red" dark  @click="VerifiedItemModal=false">
                  <v-icon> mdi-keyboard-backspace</v-icon> </v-btn
                >&nbsp;
                <v-btn color="warning" dark  @click="ClearItemModal()">
                  <v-icon>mdi-close-box</v-icon> </v-btn
                >&nbsp;
                <v-btn color="blue" dark @click="SetVerification()">
                  <v-icon>mdi-checkbox-marked</v-icon>
                </v-btn>
              </v-col></v-row
            >
          </v-sheet>
        </v-bottom-sheet> 
           <v-dialog v-model="BarcodeModal" persistent width="500">
      <v-card>
        <v-card-title
          style="color:rgb(0 99 145);font-size:17px;text-align:center"
          >Scan barcode</v-card-title
        >

        <v-card-text>
          <StreamBarcodeReader
            @decode="a => onDecode(a)"
            @loaded="() => onLoaded()"
          ></StreamBarcodeReader>
        </v-card-text>
        <v-card-actions hidden>
          <v-spacer></v-spacer>
          <v-btn
            small
            @click="BarcodeModal = false"
            style="background-color:#FB8C00;color:#FFF"
          >
            Cancel
          </v-btn>

          <v-btn
            small
            @click="BarcodeModal = false"
            style="background-color:#2E7D32;color:#FFF"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

       <v-bottom-navigation
            v-model="value"
            grow
            fixed
            bottom
            style="    box-shadow: none;"
          >
            <!-- <v-btn value="recent" @click="ClearAll()">
              <span>Clear All</span>

              <v-icon>mdi-reload</v-icon>
            </v-btn> -->
            <v-btn  @click="OpenVerificationForm()">
              <span>Verification</span>

               <v-icon style="">mdi mdi-check-decagram</v-icon>
            </v-btn>
            <v-btn value="save" @click="CheckVerification()">
              <span>Save</span>

              <v-icon>mdi-content-save</v-icon>
            </v-btn>
            <v-btn value="add"  @click="VerifiedItemModal=true">
              <span>Verify Item</span>

              <v-icon>mdi-cart-check</v-icon>
            </v-btn>
          </v-bottom-navigation>

           <v-dialog
      v-model="VoucherVerificationModal"
      max-width="400px"
      style="z-index: 100000!important;"
    >
      <v-card>
        <v-card-title style="color:rgb(238,68,170)"> </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" style="">

           
          <label style="font-size: 18px;color: #000;"
            >Which voucher should you save this as?</label
          >
           </v-col>
           <v-col cols="12" style="padding-bottom: 0px;">
              <v-combobox
              v-model="SaveVoucherType"
              :items="VoucherTypeOptions"
            label="Voucher Type"
            outlined
            dense
          ></v-combobox>
           </v-col>
            <v-col cols="12" style="padding-top: 0px;">
          <v-text-field
            label="Refer No"
            v-model="SaveReferNo"
            dense
            outlined
          ></v-text-field>
          </v-col>
                 <v-col
              cols="6"
              sm="6"
              md="6"
              class="slno"
              style="padding-top:1px;padding-bottom:10px;"
            >
              <v-btn
                text
                @click="VoucherVerificationModal = false"
                style="background-color:#FB8C00;color:#FFF"
                small
              >
                Cancel
              </v-btn>
            </v-col>
            <v-col
              cols="6"
              sm="6"
              md="6"
          
              style="padding-top:1px;padding-bottom:10px;text-align: right"
            >
              <v-btn
                small
             @click="SaveASVoucher()"
                style="background-color:#2E7D32;color:#FFF;"
              >
              Ok
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      
      </v-card>
    </v-dialog>
        <v-dialog
      v-model="VoucherValidationModal"
      max-width="450px"
      style="z-index: 100000!important;"
    >
      <v-card>
        <v-card-title style="color:rgb(238,68,170)"> </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" style="">

           
          <label style="font-size: 14px;color:red;"
            >This voucher has {{ItemDetails.length}} items, but only {{VerifiedCount}} items have been verified. Do you want to continue?</label
          >
           </v-col>
           <v-col cols="12" style="    padding-bottom: 22px;
    padding-top: 0px;">
      <v-divider></v-divider>
      </v-col>
                 <v-col
              cols="6"
              sm="6"
              md="6"
              class="slno"
              style="padding-top:1px;padding-bottom:10px;"
            >
              <v-btn
                text
                @click="VoucherValidationModal = false"
                style="background-color:#FB8C00;color:#FFF"
                small
              >
                Cancel
              </v-btn>
            </v-col>
            <v-col
              cols="6"
              sm="6"
              md="6"
          
              style="padding-top:1px;padding-bottom:10px;text-align: right"
            >
              <v-btn
                small
             
                style="background-color:#2E7D32;color:#FFF;"
                @click="VoucherVerificationModal=true"
              >
              Yes
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      
      </v-card>
    </v-dialog>

      <v-dialog
      v-model="ItemCodeModal"
      persistent
      max-width="600"
      style="z-index: 10000000!important;"
    >
      <v-card style="padding-top:20px">
        <v-card-text>
          <v-row>
            <v-col cols="10" style="font-size: 18px;padding-top: 5px;
    padding-bottom: 18px;color: #000;">
              <label>Please select Item</label>
            </v-col>
            <v-col cols="2" style="text-align: right;padding-top: 5px;
    padding-bottom: 20px;color: #000;">
              <v-icon @click="ItemCodeModal=false" style="color: #000;">mdi-close-circle</v-icon>
            </v-col>
          </v-row>
        <Itemcodescan  :ItemUnitsObject="ItemUnitsObject"   @data-transmitted="handleEventEmail"/>
        </v-card-text>
     
      </v-card>
    </v-dialog>

    
      <v-dialog v-model="UploadModal" persistent width="300">
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="12" style="padding-top: 45px;">
              <span style="font-size: 20px;">Should the voucher be uploaded?</span>
            </v-col>
            <v-col cols="12">
            <v-divider></v-divider>
            </v-col>
            <v-col cols="6" style="text-align: center;">
              <v-btn
            small
            @click="UploadVoucher(false)"
            style="background-color:#FB8C00;color:#FFF"
          >
            Cancel
          </v-btn>
              </v-col>
              <v-col cols="6" style="text-align: center;">
                <v-btn
            small
            @click="UploadVoucher(true)"
            style="background-color:#2E7D32;color:#FFF"
          >
            ok
          </v-btn>
              </v-col>

          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import axios from "axios";
import Header from "./Header.vue";
import Itemcodescan from "./Itemcodescan.vue";
 import { StreamBarcodeReader } from "vue-barcode-reader";


export default {
  components: {
    Header,StreamBarcodeReader,Itemcodescan
  },
  data() {
    return {
      snackbar: false,
      SnackbarMessege: "",
      timeout: 2000,
      bURL: localStorage.getItem("BaseURL"),
      error: "",
      Loader: false,
      AlwaysopenBarcodeScan:false,
      VerifiedItemModal:false,
      BarcodeModal: false,
      CommonObject :{
            "VoucherNo"   : "",
            "VoucherDate" : "",
            "VoucherType" : "",
            "ReferNo"   : "",
            "PartyName"   : ""
      },
      VoucherDate:"",
      ItemDetails : [],
      Barcode:"",
      ItemName:"",
      VerifyQty:"",
      ActualQty:"",
      Unit:"",
      ItemRate:"",
      ItemAmount:"",
      MatchedLabel:"",
      Itemsearch:"",
      VoucherVerificationModal:false,
      VoucherValidationModal:false,
      SaveVoucherType:"",
      VoucherTypeOptions:["Sales","Delivery Note","Purchase","Purchase Return"],
      SaveReferNo : "",
      Loaderdialog:false,
      ShowVoucherVerifyActQty:'False',
      ShowVoucherItemRate:'False',
      HideItemCostDetails:false,
       headers : {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + localStorage.getItem('Token')
              },
      IsNativeFlutterApp : true,
      ItemCodeModal:false,
      IsBarcodeScan : true,
      ItemUnitsObject : [],
      UploadModal:false,
      ActualSubTotal : 0,
      ActualNetAmount : 0,
      SubTotal : 0,
      NetAmount : 0,
      ActualTotalTax : 0,
      TotalTax : 0
 
   
    };
  },
  computed: {
      resultQuery () {
      return this.ItemDetails.filter(post => {
        return post.ItemName.toString().toLowerCase().includes(this.Itemsearch.toLowerCase()) ||
        post.ItemCode.toString().toLowerCase().includes(this.Itemsearch.toLowerCase()) ||
        post.Barcode.toString().toLowerCase().includes(this.Itemsearch.toLowerCase()) 
      })
    },
   

  },
  mounted() {
         this.GetSettings()
         //this.GetRoleSettings()
         this.VoucherEditId = localStorage.getItem('VoucherEditId')
         if(this.VoucherEditId !== null && this.VoucherEditId !== undefined)
         {
            this.AssignObject()
         }
         else{
          this.GetCommonObject()
         }
         this.IsNativeFlutterApp = localStorage.getItem("IsNativeFlutterApp");
        if (this.IsNativeFlutterApp === "true" || this.IsNativeFlutterApp === true)
        {
          this.IsNativeFlutterApp = true
        }
        else
        {
          this.IsNativeFlutterApp = false
        }
  },
 
  methods: {
     onDecode(a) {
      console.log("Result Barcode " + a);
      // this.text = a;
      if (a != null || a != "") {
        
        if(this.IsBarcodeScan === true)
        {
          this.Barcode = a;
          this.GetItemNameByBarcode()
        }
        else{
          this.ItemCode = a;
          this.GetItemNameByItemCode()
        }
        this.BarcodeModal = false;
        this.moveToNext('quantity');
     }
    },
    GetSettings()
    {
      //this.IsShowLoader = true
      axios.get(this.bURL + '/api/common/GetSettingsDictionary?BranchCode=MB&CompanyId=' +this.CompanyId)
        .then((response)  =>  {
          
          this.Settings = response.data
          this.ShowVoucherVerifyActQty = this.Settings.ShowVoucherVerifyActQty
          this.ShowVoucherItemRate = this.Settings.ShowVoucherItemRate
        }, (error)  =>  {
          //console.log(error)
        })
    },
    GetCommonObject()
    {
          this.CommonObject = JSON.parse(localStorage.getItem('VerifiedCommonObj'))
          this.VoucherDate = this.FormatDate( this.CommonObject.VoucherDate)
          this.ItemDetails = this.CommonObject.ItemDetails
          this.GetRoleSettings()
          this.FindTotal()
    },
    FindTotal()
    {
        this.ActualSubTotal = 0
        this.ActualNetAmount = 0
        this.SubTotal = 0
        this.NetAmount = 0
        this.ActualTotalTax = 0
        this.TotalTax = 0
        for(this.i=0;this.i<this.ItemDetails.length;this.i++)
        {
           this.ActualSubTotal += this.ItemDetails[this.i].Amount
           this.ActualTotalTax += this.ItemDetails[this.i].Tax
           this.ActualNetAmount += this.ItemDetails[this.i].TotalAmount
           
             this.TempTotal = 0
             this.TempDiscount = 0
             this.TempItemDic = 0
             this.TempTotal = 0
             this.TempTax = 0
            // this.SubTotal = 0
             //this.TotalTax = 0
             //this.NetAmount = 0

           if(this.ItemDetails[this.i].VerifiedQty > 0)
           {
             this.TempTotal = this.ItemDetails[this.i].VerifiedQty*this.ItemDetails[this.i].Rate
             this.TempDiscount = this.ItemDetails[this.i].Discount /this.ItemDetails[this.i].Qty
             this.TempItemDic = this.TempDiscount * this.ItemDetails[this.i].VerifiedQty
             this.TempTotal = (this.TempTotal - this.TempItemDic) 
             this.TempTax = (this.TempTotal * this.ItemDetails[this.i].TaxPerc)/100
             this.SubTotal +=   this.TempTotal
             this.TotalTax += this.TempTax 
             this.ItemDetails[this.i].VerifiedAmt = (this.TempTotal +  this.TempTax)
             this.NetAmount += (this.TempTotal +  this.TempTax)
           }
        }
    },
    AssignObject()
    {
       this.Registers = [];
      if (localStorage.getItem("VoucherRegister") != null) {
        this.Registers = JSON.parse(localStorage.getItem("VoucherRegister"));
      }
      this.CommonObject = {}
      this.VoucherObject = this.Registers[this.VoucherEditId]
      this.VoucherDate = this.FormatDate( this.VoucherObject.VoucherDate)
      this.CommonObject.VoucherDate = this.VoucherObject.VoucherDate
      this.CommonObject.PartyName = this.VoucherObject.Title
      this.CommonObject.VoucherType = this.VoucherObject.VoucherTypeFrom
      this.SaveVoucherType = this.VoucherObject.VoucherType
      this.SaveReferNo = this.VoucherObject.ReferNo
      if(this.SaveVoucherType === "S" )
        {
            this.SaveVoucherType = "Sales"
        }
        if(this.SaveVoucherType === "SO" )
        {
            this.SaveVoucherType = "Sales Order"
        }
        if(this.SaveVoucherType === "DN" )
        {
            this.SaveVoucherType = "Delivery Note"
        }
        if(this.SaveVoucherType === "P" )
        {
            this.SaveVoucherType = "Purchase"
        }
        if(this.SaveVoucherType === "LPO" )
        {
            this.SaveVoucherType = "LPO"
        }
      this.GetRoleSettings()

       if(this.VoucherObject.VoucherTypeFrom === "S" )
        {
            this.CommonObject.VoucherType = "Sales"
        }
        if(this.VoucherObject.VoucherTypeFrom === "SO" )
        {
            this.CommonObject.VoucherType = "Sales Order"
        }
        if(this.VoucherObject.VoucherTypeFrom === "DN" )
        {
            this.CommonObject.VoucherType = "Delivery Note"
        }
        if(this.VoucherObject.VoucherTypeFrom === "P" )
        {
            this.CommonObject.VoucherType = "Purchase"
        }
        if(this.VoucherObject.VoucherTypeFrom === "LPO" )
        {
            this.CommonObject.VoucherType = "LPO"
        }
      this.CommonObject.VoucherNo = this.VoucherObject.VoucherNoFrom
      this.CommonObject.ReferNo = this.VoucherObject.ReferNoFrom
      this.VoucherDetails = this.VoucherObject.VoucherDetails
      this.ItemDetails = []
       for(this.i=0;this.i<this.VoucherDetails.length;this.i++)
      { 
        
           this.ItemDetail = {
             "ItemName" : this.VoucherDetails[this.i].ItemName ,
             "Barcode"  : this.VoucherDetails[this.i].Barcode ,
             "ItemCode"  : this.VoucherDetails[this.i].ItemCode ,
             "Qty" : this.VoucherDetails[this.i].ActualQty ,
             "Rate" : this.VoucherDetails[this.i].Rate ,
             "Tax" : this.VoucherDetails[this.i].Tax ,
             "TaxPerc" : this.VoucherDetails[this.i].TaxPerc ,
             "Discount" : this.VoucherDetails[this.i].Discount ,
             "TotalAmount" : this.VoucherDetails[this.i].TotalAmount ,
             "Amount" : this.VoucherDetails[this.i].Amount ,
             "VerifiedQty" : this.VoucherDetails[this.i].Quantity ,
             "Remarks"  : "",
             "ExpiryDate": this.VoucherDetails[this.i].ExpiryDate,
           },

           this.ItemDetails.push(this.ItemDetail)
      }
      this.FindTotal()
    },
  convertDateFormat(dateString) {
    
    // Split the date string into components
    const [year, month, day] = dateString.split("-");
    
    // Return the new format
    this.Date = `${day}-${month}-${year}`
    return this.Date 
  },
    FormatDate(Value) {
      return Value.split("T")[0];
    },
    SetVoucherTime(Value)
    {
      this.Date =  new Date(Value)
      this.Hr =  this.Date.getHours()
      this.Min =  this.Date.getMinutes();
      this.ampm =  this.Hr >= 12 ? 'PM' : 'AM';
      this.Hr = this.Hr % 12;
      this.Hr = this.Hr ? this.Hr : 12; // the hour '0' should be '12'
      this.Min = this.Min < 10 ? '0'+this.Min : this.Min;
      this.VoucherTime  = this.Hr +  ":"  + this.Min + "   " + this.ampm
      return this.VoucherTime
    },
     OpenBarcodeReader()
    {
      this.IsCamera = false
          if (this.IsNativeFlutterApp === true) {
            //window.FromJavascriptScanner.postMessage('CamaraLaunchRequist');
            this.OpenBarcodeReaderFlutter()
          } 
          else
          {
             this.BarcodeModal = true
          }
    },
    OpenBarcodeReaderFlutter() {
      // Call the Flutter handler to launch the barcode scanner
      window.flutter_inappwebview.callHandler('CamaraLaunchRequist')
        .then((result) => {
          if (result) {
            // Handle the barcode result
            //console.log('Barcode scanned:', result);
            //this.GetItemByBarcode(result)
           
        if(this.IsBarcodeScan === true)
        {
          this.Barcode = result
          this.GetItemNameByBarcode()
        }
        else{
           this.ItemCode = result
          this.GetItemNameByItemCode()
        }
        this.BarcodeModal = false;
        this.moveToNext('quantity');

          } else {
            console.log('Barcode scanning cancelled or failed');
          }
        })
        .catch((error) => {
          console.error('Error launching barcode scanner:', error);
        });
    },
        
      GetItemNameByBarcode()
      {
         this.Loaderdialog = true
          axios.get(this.bURL + "/api/item/getitembybarcode?barcode=" + this.Barcode + "&PriceGroupId=0" )
          .then((response)  =>  {
             this.Loaderdialog = false
              this.ItemName = response.data.ItemName
              this.ItemCode = response.data.ItemCode
              this.AltUnitId = response.data.AltUnitId
              this.Unit = response.data.Unit
              this.VerifiedItemModal=true
              this.VerifyItem()
               setTimeout(() => {
                  this.moveToNext2()
              }, 200);
             
          }, (error)  =>  {
              this.Loaderdialog = false
             this.SnackbarMessege = "Item does not exist"
             this.snackbar = true
          })  
      },
    GetItemNameByItemCode()
      {
          this.Loaderdialog = true
          axios.get(this.bURL + "/api/item/SelectItemByItemCodeDetailed?ItemCode=" + this.ItemCode + "&PriceGroupId=0" )
          .then((response)  =>  {
             this.Loaderdialog = false
             this.ItemUnitsObject = response.data
              for(this.i = this.ItemUnitsObject.length -1;this.i>-1;this.i--)
             {
                this.flag = false
                for(this.j = 0;this.j<this.ItemDetails.length;this.j++)
                {
                  if(this.ItemUnitsObject[this.i].Barcode === this.ItemDetails[this.j].Barcode)
                  {
                      this.flag = true
                      break
                  }
                }
                if(this.flag === false)
                {
                  this.ItemUnitsObject.splice(this.i,1)
                }
             }
             if(this.ItemUnitsObject.length > 1)
             {
                for(this.i = 0;this.i<this.ItemUnitsObject.length;this.i++)
                {
                  this.ItemUnitsObject[this.i].IsSelected = false
                }
                  this.ItemCodeModal = true
             }
             else if(this.ItemUnitsObject.length === 1){
              this.handleEventEmail(0)
             }
             else{
               this.SnackbarMessege = "You cannot add an item that is not in the voucher."
              this.snackbar = true
              return
             }
             /*  this.ItemName = response.data.ItemName
              this.ItemCode = response.data.ItemCode
              this.AltUnitId = response.data.AltUnitId
              this.Unit = response.data.Unit
              this.VerifiedItemModal=true
              this.VerifyItem() */
               setTimeout(() => {
                  this.moveToNext2()
              }, 200);
             
          }, (error)  =>  {
             this.Loaderdialog = false
             this.SnackbarMessege = "Item does not exist"
             this.snackbar = true
          })  
      },
      
    handleEventEmail(Id) {

      this.ItemName = this.ItemUnitsObject[Id].ItemName
      this.Barcode = this.ItemUnitsObject[Id].Barcode
      this.ItemCode = this.ItemUnitsObject[Id].ItemCode
      this.AltUnitId = this.ItemUnitsObject[Id].AltUnitId
      this.Unit = this.ItemUnitsObject[Id].Unit
      this.VerifyItem()
      this.ItemCodeModal = false
       setTimeout(() => {
                  this.moveToNext2()
              }, 200);
    },
      SetFocusOnItemCode()
      {
        if(this.IsBarcodeScan === true)
        {
           setTimeout(() => {
                 document.getElementById('ebar').focus();
              }, 200);
        }
        else{
           setTimeout(() => {
                document.getElementById('eitemcode').focus();
              }, 200);
          
        }  
      },
      VerifyItem()
      {
          for(this.i=0;this.i<this.ItemDetails.length;this.i++)
          {
              if(this.ItemDetails[this.i].Barcode === this.Barcode)
              {
                 this.MatchedLabel = "(Item Matched)"
                 this.ActualQty = this.ItemDetails[this.i].Qty
                 this.Unit = this.ItemDetails[this.i].Unit
                 this.VQty = parseFloat(this.ItemDetails[this.i].VerifiedQty)
                 if(isNaN(this.VQty) || this.VQty === 0)
                 {
                    this.VQty = ""
                 }
                 this.VerifyQty = this.VQty
                 this.ItemRate = this.ItemDetails[this.i].Rate
                 this.ItemAmount = this.ItemDetails[this.i].TotalAmount
                 break
              }
              else{
                this.MatchedLabel = "(New Item)"
                 this.ActualQty = ""
                 this.Unit = ""
              }
          }
      },
       moveToNext2() {
    
    const nextField = document.getElementById('quantity'); // Get the next field
    nextField.focus(); // Move focus to the next field
  
    },
    moveToNext(nextFieldId) {
      const currentField = document.activeElement; // Get the current active field
      if (currentField.value.length > 0) {
      const nextField = document.getElementById(nextFieldId); // Get the next field
      nextField.focus(); // Move focus to the next field
  }
  },
  OpenVerifiedItemModal(item)
  {
    this.Barcode = item.Barcode
    this.GetItemNameByBarcode()
    
  },
  ClearItemModal()
  {
      this.Barcode = ""
      this.ItemCode = ""
      this.ItemName = ""
      this.ActualQty = ""
      this.Unit = ""
      this.VerifyQty = ""
      this.ItemRate = ""
      this.ItemAmount = ""
  },
  SetVerification()
  {
    this.VerifyQty = parseFloat(this.VerifyQty)
    this.flag = isNaN(this.VerifyQty)
    if(this.flag === true)
    {
       this.VerifyQty = 0
    }
    if(this.VerifyQty === 0)
    {
        this.SnackbarMessege = "Enter Qty"
        this.snackbar = true
        return
    }
      this.IsHave = false
      this.IsExcessQty = false
       for(this.i=0;this.i<this.ItemDetails.length;this.i++)
          {
              if(this.ItemDetails[this.i].Barcode === this.Barcode)
              {
                if(this.ItemDetails[this.i].Qty < this.VerifyQty)
                {
                    this.SnackbarMessege = "You cannot add more quantity than is on the voucher."
                    this.snackbar = true
                    this.IsExcessQty = true
                    break
                    
                }
                else{
                   this.ItemDetails[this.i].VerifiedQty = this.VerifyQty
                  this.IsHave = true
                  break
                 }
              }
          }
          if(this.IsHave === false && this.IsExcessQty=== false)
          {
            /* this.itemObj = {
                "ItemName" : this.ItemName,
                "ItemCode" : this.ItemCode,
                "Barcode" : this.Barcode,
                "AltUnitId" : this.AltUnitId,
                "Unit" : this.Unit,
                "Qty" : 0,
                "VerifiedQty" : this.VerifyQty
              }
              this.ItemDetails.push( this.itemObj) */
              this.SnackbarMessege = "You cannot add an item that is not in the voucher."
              this.snackbar = true
              return
          }
          this.FindTotal()
          if(this.IsHave === true)
          {
           this.ClearItemModal()
          }
  },
  GetVerifiedCount()
  {
       this.VerifiedCount = 0
       for(this.i=0;this.i<this.ItemDetails.length;this.i++)
       {
          if(this.ItemDetails[this.i].Qty === this.ItemDetails[this.i].VerifiedQty)
          {
            this.VerifiedCount ++
          }
       }
       return this.VerifiedCount
  },
     OpenVerificationForm(){
      this.$router.push("VerifyVoucher");
    },
    CheckVerification()
    {
        this.VerifiedCount = this.GetVerifiedCount()
        if(this.VerifiedCount !== this.ItemDetails.length)
        {
            this.VoucherValidationModal = true
        }
        else{
           this.VoucherVerificationModal = true
        }
    },
    SaveASVoucher()
    {
       if(this.SaveVoucherType === "" )
       {
          this.SnackbarMessege = "Select voucher type"
          this.snackbar = true
          return
       }
       if(this.SaveVoucherType === this.CommonObject.VoucherType)
       {
          this.SnackbarMessege = "You cannot select voucher types are same"
          this.snackbar = true
          return
       }
       this.Registers = [];
      if (localStorage.getItem("VoucherRegister") != null) {
        this.Registers = JSON.parse(localStorage.getItem("VoucherRegister"));
      }
       if(this.CommonObject.VoucherType === "Sales")
        {
            this.VoucherTypeFrom = "S"
        }
        if(this.CommonObject.VoucherType === "Sales Order")
        {
            this.VoucherTypeFrom = "SO"
        }
        if(this.CommonObject.VoucherType === "Delivery Note")
        {
            this.VoucherTypeFrom = "DN"
        }
        if(this.CommonObject.VoucherType === "Purchase")
        {
            this.VoucherTypeFrom = "P"
        }
        if (this.CommonObject.VoucherType === "LPO"){
          this.VoucherTypeFrom = "LPO"
        }

        if(this.SaveVoucherType === "Delivery Note")
        {
          this.FinalSaveVoucherType = "DN"
        }
        if(this.SaveVoucherType === "Sales")
        {
          this.FinalSaveVoucherType = "S"
        }
        if(this.SaveVoucherType === "Sales Order")
        {
          this.FinalSaveVoucherType = "SO"
        }
        if(this.SaveVoucherType === "Purchase")
        {
          this.FinalSaveVoucherType = "P"
        }
         if(this.SaveVoucherType === "Purchase Return")
        {
          this.FinalSaveVoucherType = "PR"
        }
        if (this.SaveVoucherType === "LPO"){
          this.FinalSaveVoucherType = "LPO"
        }

         const now = new Date()
        const time =
        String(now.getHours()).padStart(2, '0') + ':' +
        String(now.getMinutes()).padStart(2, '0') + ':' +
        String(now.getSeconds()).padStart(2, '0')


       this.myobj = {
        VoucherType: this.FinalSaveVoucherType,
        VoucherNo: this.SaveReferNo?this.SaveReferNo:"",
        ReferNo : this.SaveReferNo?this.SaveReferNo:"",
        Title: this.CommonObject.PartyName,
        VoucherDate: new Date().toISOString().substr(0, 10) + "T" + time,
        VoucherExpiryDate: new Date().toISOString().substr(0, 10),
        Remarks: "",
        UploadStatus: false,
        VoucherTypeFrom:this.VoucherTypeFrom,
        VoucherNoFrom : this.CommonObject.VoucherNo,
        ReferNoFrom : this.CommonObject.ReferNo,
        VoucherDetails:[]
      };
      this.VoucherDetails = []
      for(this.i=0;this.i<this.ItemDetails.length;this.i++)
      { 
        if(this.ItemDetails[this.i].VerifiedQty > 0)
        {
           this.ItemDetail = {
             "ItemName" : this.ItemDetails[this.i].ItemName ,
             "Barcode"  : this.ItemDetails[this.i].Barcode ,
             "ItemCode"  : this.ItemDetails[this.i].ItemCode ,
             "Quantity" : this.ItemDetails[this.i].VerifiedQty ,
             "ActualQty" : this.ItemDetails[this.i].Qty ,
             "Rate" : this.ItemDetails[this.i].Rate ,
             "Tax" : this.ItemDetails[this.i].Tax ,
             "TaxPerc" : this.ItemDetails[this.i].TaxPerc ,
             "Discount" : this.ItemDetails[this.i].Discount ,
             "TotalAmount" : this.ItemDetails[this.i].TotalAmount ,
             "Amount" : this.ItemDetails[this.i].Amount ,
             "Remarks"  : "" ,
             ExpiryDate: new Date().toISOString().substr(0, 10),
           }
           this.VoucherDetails.push(this.ItemDetail)
          }
      }
      if(this.CommonObject.VoucherNoFrom === "" || this.VoucherDetails.length === 0)
      {
        this.SnackbarMessege = "Please enter details"
        this.snackbar = true
        return
      }
      this.UploadObject = this.myobj
      this.myobj.IsFromVerify = true
       this.myobj.VoucherDetails =  this.VoucherDetails

       if(this.VoucherEditId !== null && this.VoucherEditId !== undefined && this.VoucherEditId !== -1)
      {
        this.Registers[this.VoucherEditId] = this.myobj
      }
      else
      {
        this.Registers.push(this.myobj);
      }
       localStorage.setItem("VoucherRegister", JSON.stringify(this.Registers));
        this.ClearVerification()
         this.SnackbarMessege = "Saved"
         this.snackbar = true;
         this.VoucherVerificationModal = false
         this.VoucherValidationModal = false

          this.UploadModal = true
     
    },
    UploadVoucher(IsUpload)
    {
         if(IsUpload === true)
         {
           this.ExcecuteUpload()
         }
         else{
           this.ClearVerification()
           this.$router.push("VerifyVoucher");
         }
    },
    ExcecuteUpload()
    {
      this.Loaderdialog = true
        axios.post(this.bURL + '/api/PDTvoucher',this.UploadObject,
          {
                headers: this.headers
          })
          .then((response)  =>  {
               this.VoucherRegister = localStorage.getItem("VoucherRegister")
               if(this.VoucherRegister !== null)
               {
                 this.VoucherRegister = JSON.parse(this.VoucherRegister)
               }
               this.VoucherRegister[this.VoucherRegister.length-1].UploadStatus = true
               localStorage.setItem('VoucherRegister',JSON.stringify(this.VoucherRegister))
              this.Loaderdialog = false

             this.ClearVerification()
             this.$router.push("VerifyVoucher");
            
          },
           (error)  =>  {
          this.isLoading = false
          this.isSignInDisabled = false
          this.timeout = 3000
          this.SnackbarColor = 'red'
          if(error.response === undefined)
          {
            this.SnackbarMessege = this.$t(`menu.CheckyourInternetConnection`)
          }
          else if(error.response.data !=="")
          {
            this.SnackbarMessege = error.response.data
          }
          else if(error.response.status === 401)
          {
             this.GlobalPasswordModal = true
          }
           else{
             this.SnackbarMessege = this.$t(`menu.CheckyourInternetConnection`)
           }
          this.snackbar = true
        })
    },
    ClearVerification()
    {
       
        this.CommonObject ={
            "VoucherNo"   : "",
            "VoucherDate" : "",
            "VoucherType" : "",
            "ReferNo"   : "",
            "PartyName"   : "",
            "VoucherTypeFrom": "",
            "VoucherNoFrom": ""
      },
      this.ItemDetails = []
      localStorage.removeItem('VerifiedCommonObj'),
      this.VerifiedCount = 0
      
    },
     FormatewithDecimalPlacesNew(value) {
      this.number = localStorage.getItem("symbol");
        //let val = (value / 1).toFixed(this.number).replace(".", ".");
        //return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

        value = parseFloat(value);
        if(isNaN(value)  === true)
        {
          value = 0
        }
        return value.toFixed(this.number);
      
    },
    GetRoleSettings()
    {
       this.UserDetails = JSON.parse(localStorage.getItem('User'))
       axios.get(this.bURL + '/api/common/GetRoleSettingsDictionary?RoleName='+ this.UserDetails.userType)
        .then((response)  =>  {
          
             this.HideItemCostDetails = response.data.HideItemCostDetails
             if (this.HideItemCostDetails === "True" && (this.CommonObject.VoucherType === 'Purchase' || this.CommonObject.VoucherType === 'Purchase Return' || this.CommonObject.VoucherType === 'LPO')) 
                this.HideItemCostDetails = true;
             else 
                this.HideItemCostDetails = false;

        }, (error)  =>  {
          console.log(error)
        })
    },
   
  },
};
</script>
<style scoped>
.locationnew{
    text-align: right !important;
}
</style>